import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useState, useEffect } from "react";
import { logout } from "../../actions/user";
import { useNavigate } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import { Button, Typography, Image, Spin } from "antd";
import { goBackToWebsite, getParam } from "../../utills/common";
import { UNAUTHENTICATED, UNAUTHORIZED } from "../../utills/icons";

const { Title, Paragraph } = Typography;
const referrerURL = getParam(window.location, "referrer");

const ErrorPage = ({ error, logout, referrer = referrerURL, resetErrorBoundary }) => {
  const navigate = useNavigate();
  const [authTimeout, setAuthTimeOut] = useState(10);
  const isErrorBoundary = error?.hasOwnProperty("stack");

  useEffect(() => {
    let authTimeoutInterval = null;
    if (error.status === 401) {
      logout();
      goBackToWebsite(referrer);
    }

    if (!isErrorBoundary) {
      authTimeoutInterval = setInterval(() => {
        if (authTimeout <= 1) {
          clearInterval(authTimeoutInterval);
          goBackToWebsite(referrer);
        } else {
          setAuthTimeOut((t) => t - 1);
        }
      }, 1000);
    }

    return () => {
      authTimeoutInterval && clearInterval(authTimeoutInterval);
    };
  });

  return error?.status !== 401 ? (
    <div className='flex-item flex-center h-100vh w-100'>
      <div className='flex-item flex-column'>
        <Image src={error.status === 403 ? UNAUTHORIZED : UNAUTHENTICATED} preview={false} />
        <Title level={3} className='mt-4 mb-0'>
          {!isErrorBoundary ? error.message : "Sorry, some error occurred while loading the page."}
        </Title>

        {!isErrorBoundary && (
          <>
            {error.status === 403 && (
              <Title level={3} className='fwn mt-2'>
                Sorry, you do not have authorized access to view this page.
              </Title>
            )}

            {error.status !== 403 && (
              <>
                <Title level={3} className='fwn m-0 mt-2'>
                  Oops, looks like you drifted away
                </Title>
                {/* <Title level={3} className='fwn mt-1'>
                  Please sign in again to continue.
                </Title> */}
              </>
            )}

            <Paragraph className='text-black fwn'>
              Your session timed out. Redirecting you to the dashboard in {authTimeout} seconds.
            </Paragraph>
          </>
        )}

        <div className='d-flex mt-2'>
          <Button
            type='primary'
            className='font-bold br-10px'
            onClick={() => {
              if (!referrer) navigate("/");
              else goBackToWebsite(referrer);

              resetErrorBoundary && resetErrorBoundary();
            }}
          >
            Back to Dashboard
          </Button>

          {isErrorBoundary && (
            <Button key='retry' className='font-bold br-10px ml-2' onClick={resetErrorBoundary}>
              Retry
            </Button>
          )}
        </div>
      </div>
    </div>
  ) : (
    <div className='flex-item flex-center h-100vh w-100'>
      <Spin spinning={true} indicator={<LoadingOutlined />} tip={<Title level={5}>Please wait...</Title>}></Spin>
    </div>
  );
};

ErrorPage.propTypes = {
  logout: PropTypes.func,
  error: PropTypes.object,
  referrer: PropTypes.string,
};

export default connect(null, { logout })(ErrorPage);
